import { StackScreenProps } from "@react-navigation/stack";
import { Button, Page } from "@towersystems/roam-common-native";
import React from "react";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { StockCountItemHistoryRootScreenParamList } from "../../../../types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { PlaceholderLoadingScreen } from "../../../products/screens/PlaceholderLoadingScreen";
import { useSelectedStockCountItemContextProvider } from "../../utils/count-stock/hooks";
import { StockCountHistoryContent } from "../StockCountScreen/components";

export type StockCountItemHistoryScreenProps = StackScreenProps<
  StockCountItemHistoryRootScreenParamList,
  "StockCountItemHistoryScreen"
>;

export const StockCountItemHistoryScreen = ({
  navigation,
}: StockCountItemHistoryScreenProps) => {
  const { stockCountLineItem } = useSelectedStockCountItemContextProvider();
  const transitionEnded = useHasTransitionEnded(navigation);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        stockCountLineItem.product?.id ? (
          <Button
            label="Edit product"
            isAction
            size="compact"
            onPress={() =>
              navigation.navigate("EditProductRootScreen", {
                productId: stockCountLineItem.product.id,
                screen: "EditProductScreen",
              })
            }
          />
        ) : undefined,
    });
  }, [stockCountLineItem.product?.id]);

  if (false == transitionEnded) {
    return (
      <Page>
        <PlaceholderLoadingScreen
          navigation={navigation}
          content={<FlatListSearchableSkeleton searchbar={false} />}
          modifyHeader={false}
        />
      </Page>
    );
  }

  return (
    <Page title="Count History" secondaryTitle={stockCountLineItem.barcode}>
      <StockCountHistoryContent stockCountLine={stockCountLineItem} />
    </Page>
  );
};
